import Icon from "./Icon";
import DOMPurify from "dompurify";
import PriceBox from "./PriceBox";

function AddOns(props) {
  let outerClassName = " tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-grid-rows-auto";

  outerClassName += ' tw-gap-x-2 tw-gap-y-2';
  let innerClassName = " md:tw-space-x-5 tw-flex-row";

  let imageOuterClassName = "md:tw-w-20 md:tw-h-16";
  let imageInnerClassName = "md:tw-w-16 md:tw-h-16";

  let textClassName = "tw-text-lg tw-font-condensed tw-italic md:tw-uppercase md:tw-flex-1";
  textClassName += " xs:tw-leading-tight tw-p-0 tw-m-0 tw-break-words md:tw-break-normal";
  const lang = props.lang;
  return (
    <ul className={outerClassName+" tw-my-2 tw-min-h-[13rem] md:tw-min-h-[20rem]"}>
      {props.items.map((item, index) => {
        let icon = item.icon,
            priceModule = (item.icon == 'pricemodule') ? true : false,
            bgColor = (priceModule) ? 'tw-bg-teal' : 'tw-bg-gray-light',
            bottomInfo = item[lang].bottom_info != '' ? (<strong className="tw-mt-auto tw-font-text">{item[lang].bottom_info}</strong>) : '';
        if(priceModule){
          return (<li  
            key={"flex-list_" + index}
            className={bgColor+" tw-rounded-xl"}>
            <PriceBox prices={props.prices.items[lang]}/>
           
          </li>)
        }
        return (
          <li  
            key={"flex-list_" + index}
            className={bgColor+" tw-rounded-xl tw-flex tw-flex-col tw-p-2 md:tw-p-5"}>
            <div
            className={`${innerClassName} tw-flex tw-justify-start tw-mb-2`}
           
          >
            <div
              className={`${imageOuterClassName} tw-pr-2 tw-w-auto tw-h-auto tw-rounded-lg tw-flex tw-justify-center`}
            >
              <Icon
                icon={icon ?? "inklusive"}
                // size={32}
                className={`${imageInnerClassName} tw-w-8 tw-h-8 tw-text-teal`}
              />
            </div>
            <p
              className={`${textClassName} tw-text-black tw-items-center tw-flex !tw-ml-0`}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(item[lang].title),
              }}
            ></p>
          </div>
          <div className={`tw-font-text tw-text-black tw-block tw-pt-0 tw-pb-4 `}>
              <div
                
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item[lang].text),
                }}
              ></div>
          </div>
              {bottomInfo} 
          </li>
        );
      })}
    </ul>
  );
}

export default AddOns;